import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultAnswers, isQuestionsAnswered } from "../helpers";

import {
  getAppraisalData,
  getQuestionsByCategory,
  getSourceSystemNameIsSell
} from "../../store/selectors/AppraisalSlice";
import { appraisalSlice } from "../../store/slices/Appraisal";
import {
  ConditionalQuestionsFromAssumptionsIds,
  QuestionData
} from "../../data/QuestionData";
import { useNavigate } from "react-router-dom";
import { sendEvent, setAnalyticsLabel } from "../../helpers/analytics";
import { QuestionIds } from "../../data/QuestionPresentation";

export function useFactualQuestionsCompactView() {
  const factualQuestions: Question[] = useSelector(
    getQuestionsByCategory("Factual")
  );
  const assumptionQuestions: Question[] = useSelector(
    getQuestionsByCategory("Assumption")
  );
  const [assumptionsLoaded, setAssumptionsLoaded] = useState(false);
  const { questionsAndAnswers }: { questionsAndAnswers: ChosenAnswer[] } =
    useSelector(getAppraisalData);
  const dispatch = useDispatch();
  const [isContinueClicked, setIsContinueClicked] = useState<boolean>(false);
  const isSourceSystemNameSell = useSelector(getSourceSystemNameIsSell);
  const navigate = useNavigate();
  const assumptionsMinusConditionQuestions = assumptionQuestions.filter(
    (question) => !ConditionalQuestionsFromAssumptionsIds.includes(question.id)
  );
  const FACTUAL_QUESTIONS_FOR_ANALYTICS = [QuestionIds.SERVICEHISTORY];
  const defaultAssumptions: ChosenAnswer[] = getDefaultAnswers(
    assumptionsMinusConditionQuestions
  );
  useEffect(() => {
    if (!assumptionsLoaded) {
      setAssumptionsLoaded(true);
      dispatch(
        appraisalSlice.actions.setQuestionsAndAnswers(defaultAssumptions)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, assumptionsLoaded, setAssumptionsLoaded]);

  const factualQuestionsIds: number[] = factualQuestions.map(
    (question) => question.id
  );

  const handleSubmit = (questions: Question[]) => {
    setIsContinueClicked(true);
    dispatch(
      appraisalSlice.actions.setConditionalAnswersSubmitted([
        ...factualQuestionsIds
      ])
    );
    if (isQuestionsAnswered(questions, questionsAndAnswers)) {
      // Send analytics event for questions to be tracked
      questions.forEach((question) => {
        if (!FACTUAL_QUESTIONS_FOR_ANALYTICS.includes(question.id)) return;
        sendEvent("event", "interaction", {
          action: question.content,
          label: setAnalyticsLabel(
            question,
            questionsAndAnswers[question.id]?.[0]
          )
        });
      });
      navigate("/branch/condition");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleChange = (answer: number, question: number) => {
    if (
      isSourceSystemNameSell &&
      question === QuestionData.privateHireQuestionId
    )
      return;
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({ [question]: [answer] })
    );
  };

  return {
    factualQuestions,
    handleSubmit,
    handleChange,
    questionsAndAnswers,
    isContinueClicked
  };
}
